import { createContent } from '@altify/utils';

export const content = createContent({
  en: {
    tradePrice: 'Trade Price',
    rewardLevel: 'Altify Rewards',
    smartTrade: 'Trade With Leading Prices',
    tradingFee: 'Trading Fee',
    tradePriceSubtitle:
      'The price we show you is the actual buy price based on the total value of your trade.',
    rewardLevelSubtitle:
      'You unlock loads of great perks with Altify Rewards, including lower fees, exclusive merchandise, dedicated support, and so much more',
    smartTradeSubtitle:
      'Our Smart Trade system automatically connects you to the top crypto exchanges in real-time to get you the best prices whenever you buy or sell.',
    tradingFeeSubtitle(tierName: string, percentageDiscount: number): string {
      return `As a ${tierName} account holder, you get a ${percentageDiscount}% trading fee discount.`;
    },
    gotIt: 'Got it',
  },
  de: {
    tradePrice: 'Trade Preis',
    rewardLevel: 'Altify Rewards',
    smartTrade: 'Trade mit Spitzenpreisen',
    tradingFee: 'Trading-Gebühren',
    tradePriceSubtitle:
      'Der Preis, den wir dir zeigen, ist der tatsächliche Kaufpreis, basierend auf dem Gesamtwert deines Trades.',
    rewardLevelSubtitle:
      'Mit Altify Rewards schaltest du viele tolle Vorteile frei, darunter niedrigere Gebühren, exklusives Merchandise, persönlichen Support und vieles mehr.',
    smartTradeSubtitle:
      'Unser Smart-Trade-System verbindet dich automatisch mit den führenden Krypto-Börsen in Echtzeit, um dir bei jedem Kauf oder Verkauf die besten Preise zu sichern.',
    tradingFeeSubtitle(tierName: string, percentageDiscount: number): string {
      return `Als Kontoinhaber von ${tierName} erhältst du einen Rabatt von ${percentageDiscount}% auf die Trading-Gebühren.`;
    },
    gotIt: 'Verstanden',
  },
});
